module.exports = __webpack_public_path__ + "img/shoufei.91d3ee37.png";